import React from 'react';
import { ScrollArea } from './ui/scroll-area';
import { Badge } from './ui/badge';

export const EventTimeline = ({ events = [] }) => {
  if (!events || events.length === 0) {
    return (
      <div className="text-sm text-muted-foreground text-center py-8">
        No events yet
      </div>
    );
  }

  const sortedEvents = [...events].reverse();

  const stageColors = {
    script: 'bg-blue-100 text-blue-700',
    audio: 'bg-teal-100 text-teal-700',
    video: 'bg-amber-100 text-amber-700',
  };

  const eventTypeIcons = {
    started: 'bg-blue-500',
    completed: 'bg-emerald-500',
    failed: 'bg-red-500',
    submitted: 'bg-amber-500',
    approved: 'bg-emerald-500',
    polling: 'bg-amber-400',
    timeout: 'bg-red-500',
  };

  return (
    <ScrollArea className="h-64" data-testid="event-timeline">
      <div className="space-y-3 pr-3">
        {sortedEvents.map((event, idx) => (
          <div key={event.id || idx} className="flex gap-3 items-start">
            <div className="flex flex-col items-center">
              <div className={`w-2.5 h-2.5 rounded-full mt-1 ${eventTypeIcons[event.event_type] || 'bg-slate-400'}`} />
              {idx < sortedEvents.length - 1 && <div className="w-px h-full bg-border min-h-[20px]" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-0.5">
                <Badge className={`text-[10px] px-1.5 py-0 border-0 ${stageColors[event.stage] || 'bg-slate-100 text-slate-700'}`}>
                  {event.stage}
                </Badge>
                <span className="text-xs font-medium capitalize">{event.event_type}</span>
              </div>
              <p className="font-mono text-[10px] text-muted-foreground">
                {event.created_at ? new Date(event.created_at).toLocaleString() : ''}
              </p>
              {event.payload?.error && (
                <p className="text-xs text-red-500 mt-0.5 truncate">{event.payload.error}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
};
